import { createContext, useContext, useEffect, useState } from "react";
import { api, setCsrfToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const onExpired = () => {
      setCsrfToken("");
      setUser(null);
    };
    window.addEventListener("masandi:auth-expired", onExpired);
    return () => window.removeEventListener("masandi:auth-expired", onExpired);
  }, []);

  useEffect(() => {
    let active = true;
    api.me()
      .then(async (u) => {
        await api.refreshCsrf();
        if (active) setUser(u);
      })
      .catch(() => {
        setCsrfToken("");
        if (active) setUser(null);
      })
      .finally(() => {
        if (active) setReady(true);
      });
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    const data = await api.login(email, password);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try {
      await api.logout();
    } finally {
      setCsrfToken("");
      setUser(null);
    }
  };

  return <AuthContext.Provider value={{ user, ready, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
